import {
    StillingWithForloebKladderResponseModel
} from "../../../services/api/forloeb/uddannelsesstedForloebKladderResponseModel";
import {ForloebKladdeModel} from "./forloebKladdeModel";

export class StillingForloebKladderOverviewModel {

    public static FromResponseModel(responseModel: StillingWithForloebKladderResponseModel): StillingForloebKladderOverviewModel {
        const model = new StillingForloebKladderOverviewModel();
        model.stillingId = responseModel.stillingId;
        model.stillingNummer = responseModel.stillingNummer;
        model.forloebKladde = responseModel.forloebKladder.map(l => ForloebKladdeModel.FromResponseModel(l));
        return model;
    }

    stillingId: string;
    stillingNummer: string;
    forloebKladde: ForloebKladdeModel[];
}
